import React from "react";
import CardWrapper from "../../component/CardWrapper";
import Card from "../../component/Card";
import RevenueDashboard from '../../component/Displays/Tables/RevenueDashboard';
import {useSelector} from "react-redux";
import './index.scss';

const SiteLeaderboards: React.FC<any> = ({}) => {

	const selectedBrand = useSelector(
		(state: any) => state.brand.selectedBrand
    );

    return (
        <div className="leaderboard-container">
            <div className="guages">
                <CardWrapper>
                    <Card content={<>select chart</>} />
                </CardWrapper>
            </div>
            <div className="cards">
                <CardWrapper>
                    <Card content={<RevenueDashboard brand={selectedBrand}/>} />
                </CardWrapper>
            </div>
        </div>
    );
}

export default SiteLeaderboards;